import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M3.933 11.113h16.134M3.933 7.31h16.134M3.933 3.507h16.134m2.2 11.408h-7.334c0 1.68-1.313 3.043-2.933 3.043-1.62 0-2.933-1.362-2.933-3.043H1.733a.747.747 0 0 0-.733.761v3.803C1 20.319 1.657 21 2.467 21h19.066c.81 0 1.467-.681 1.467-1.521v-3.803c0-.42-.328-.76-.733-.76z" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
